import script from "./BoosterCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoosterCard.vue?vue&type=script&setup=true&lang=ts"

import "./BoosterCard.vue?vue&type=style&index=0&id=4ad5656e&scoped=true&lang=css"
import "./BoosterCard.vue?vue&type=style&index=1&id=4ad5656e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad5656e"]])

export default __exports__